<template>
    <div v-if="session">
        <top-navbar padding="6" :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">

            <div class="row">
                <div class="col-md-12">
                    <session-header :session="session" :status-data="statusData" :status-colors="statusColors"></session-header>
                    <session-steps :session="session" current="summary"></session-steps>
                    <session-summary
                        :session="session"
                        :stats="stats"
                        @reload-session="loadSession"
                    ></session-summary>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SessionFeatures from './sessions/SessionFeatures'
    import SessionHeader from './sessions/SessionHeader';
    import SessionSteps from './sessions/SessionSteps';
    import SessionSummary from './sessions/SessionSummary';

    export default {

        components: {
            SessionHeader, SessionSteps, SessionSummary
        },

        data() {
            return {
                session: null,
                stats: null,
                statusData: [],
                statusColors: {},
                features: new SessionFeatures(this.$router, this.$auth),
                reloaderId: null,
            }
        },

        computed: {

            breadcrumb() {
                return [
                    {
                        name: this.$t('common.sessions'),
                        route: '/socrates/ui/dashboard/sessions'
                    },
                    {
                        name: this.session.cohort.name + ' / ' + this.session.degree.name,
                        route: '/socrates/ui/dashboard/sessions/registrations/' + this.session.registration_id
                    },
                    {
                        name: this.session.learner.name,
                    },
                ]
            },

            canStartReloader() {
                return !this.session.sync && this.features.ownSession(this.session) && (this.session.status != 'closed' && this.session.status != 'archived')
            },
        },

        beforeRouteEnter(to, from, next) {
            Vue.prototype.$loader.show()
            axios.get('/socrates/api/front/dashboard/page/sessions/' + to.params.id + '/summary', { params: {
                include: ['status_data', 'status_colors', 'rights']
            }})
            .then(resp => {
                next(vm => {
                    vm.session = resp.data.data
                    vm.statusData = resp.data.included.status_data
                    vm.statusColors = resp.data.included.status_colors
                    vm.$permissions.setRights(resp.data.included.rights)
                    vm.loadStats()
                })
            })
            .catch(err => {
                if (err.response.status == 403) {
                    next({ name: 'unauthorized' });
                } else if (err.response.status == 444) {
                    // This may happen if the connection fails with an online session.
                    next({ name: 'home' });
                }
            });
        },

        beforeDestroy() {
            this.clearReloader()
        },

        methods: {

            clearReloader() {
                if (this.reloaderId) {
                    clearInterval(this.reloaderId)
                }
            },

            initReloader() {
                if (!this.reloaderId && this.canStartReloader) {
                    this.reloaderId = setInterval(() => { this.loadSession() }, 3000)
                }
                if (this.reloaderId && !this.canStartReloader) {
                    clearInterval(this.reloaderId)
                    this.reloaderId = null
                }
            },

            loadSession() {
                axios.get('/socrates/api/front/dashboard/page/sessions/' + this.session.id + '/summary')
                .then(resp => {
                    this.session = resp.data.data

                    if (this.features.redirectOwnerIfSessionChanged(this.session)) {
                        return
                    }

                    this.loadStats()
                })
                .catch(err => {
                    if (err.response.status == 500) {
                        // Do nothing. This may happen occasionally.
                    } else if (err.response.status == 403) {
                        // The session may have been reset. Go back to the configuration page or the sessions page depending of the rights.
                        if (this.features.hasTesterPermission(this.session)) {
                            this.features.openConfiguration(this.session)
                        } else {
                            this.features.openRegistrationSessions(this.session)
                        }
                    } else {
                        if (err.response.status == 444) {
                            // This may happen if the connection fails with an online session.
                            this.$router.push({ name: 'home'})
                        } else {
                            this.$auth.handleErrorVm(err, this)
                        }
                    }
                })        
            },

            loadStats() {
                axios.get('/socrates/api/front/dashboard/data/sessions/' + this.session.id + '/summary/stats')
                .then(resp => {
                    this.stats = resp.data.data
                    this.$loader.hide()
                    this.initReloader()
                })
            },
        },
    }
</script>
